import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    tvStationGroups: [],
    tvStationGroup: {},
    tvStationGroupMetadata: {}
  }
})
  .get({
    action: 'getTvStationGroups',
    property: 'tvStationGroups',
    queryParams: true,
    path: '/tv-station-groups/',
    onSuccess: payloadToState('tvStationGroups')
  })
  .post({
    action: 'createTvStationGroup',
    property: 'tvStationGroup',
    path: '/tv-station-groups/',
    onSuccess: payloadToState('tvStationGroup')
  })
  .get({
    action: 'getTvStationGroup',
    property: 'tvStationGroup',
    path: ({ id }) => `/tv-station-groups/${id}`,
    onSuccess: payloadToState('tvStationGroup')
  })
  .put({
    action: 'updateTvStationGroup',
    property: 'tvStationGroup',
    path: ({ id }) => `/tv-station-groups/${id}`,
    onSuccess: payloadToState('tvStationGroup')
  })
  .delete({
    action: 'deleteTvStationGroup',
    property: 'tvStationGroup',
    path: ({ id }) => `/tv-station-groups/${id}`,
    beforeRequest: getOptimisticDelete('tvStationGroups'),
    onSuccess: payloadToState('tvStationGroup')
  })
  .getStore()
